import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

export const TeamName = observer(function TeamName(props: {
	gender?: number;
	name: string;
}) {
	const { t } = useTranslation();

	if (props.gender === 1) {
		return (
			<span className="match__team__inner">
				{props.name} ({t("OFFER.GENDER.WOMEN")})
			</span>
		);
	}

	return <span className="match__team__inner">{props.name}</span>;
});
